import { computed, inject, Provider, signal } from '@angular/core';
import { AuthenticationService } from 'authentication-data';
import { NavItemType, provideNavItems } from 'navigation-data';
import { provideOrdersFeatureRoutes } from './orders-feature.routes';

export function provideOrdersFeature(): Provider {
  return [
    provideOrdersFeatureRoutes(),
    provideNavItems({
      type: NavItemType.RouteLink,
      id: 'app.main-menu/orders',
      label: signal($localize`:@@MainMenu_OrdersTitle:Orders`),
      icon: signal('receipt_long'),
      priority: signal(70),
      command: signal([`/orders`]),
      hidden: () => {
        const auth = inject(AuthenticationService);
        return computed(() => !auth.isAuthenticated() || !auth.user()?.customerNumbers?.length);
      },
    }),
  ];
}
